import { FilterChip, StarIcon } from '@marqvision/shared';
import { ResponsiveProps } from '~/components/Responsive/@types';
import { useLogger } from '~/hooks';
import { getListingTabGroup } from '~/utils';
import { useGetFilterParams, usePathParams } from './@hooks';

export const LikelyCounterfeitFilter = (props: ResponsiveProps) => {
  const { size = 'medium' } = props;
  const { requestFilterParams, setParams } = useGetFilterParams();
  const { gen_ai_counterfeit_filter: likelyCounterfeit } = requestFilterParams;
  const { page, listingStatus } = usePathParams();

  const { amplitudeLogging } = useLogger();
  const handleChange = () => {
    const newState = !likelyCounterfeit;
    if (newState) {
      amplitudeLogging('applied filter', {
        Type: 'likely counterfeit',
        Channel: page,
        Page: getListingTabGroup(listingStatus),
      });
    }
    setParams({
      likely_counterfeit: !likelyCounterfeit,
    });
  };

  return (
    <FilterChip
      size={size}
      type="toggle"
      selected={!!likelyCounterfeit}
      label="Likely counterfeit"
      startIcon={<StarIcon size={16} />}
      onClick={handleChange}
    />
  );
};
